import React from 'react';
import PropTypes from 'prop-types';
import '../OfficesPage.scss'
import EmployeesQueueTableSortHeader from './EmployeesQueueTableSortHeader';
import EmployeesQueueTableColumnHeader from './EmployeesQueueTableColumnHeader';
import EmployeesQueueTableNoResults from './EmployeesQueueTableNoResults';
import EmployeesQueueTableRow from './EmployeesQueueTableRow';
import EmployeesQueueTableLoader from './EmployeesQueueTableLoader';
import EmployeesQueueTablePages from './EmployeesQueueTablePages';


const EmployeesQueueTable = (props) => {
    return (
        <div id='queue-table'>
            <EmployeesQueueTableSortHeader {...props} />
            <EmployeesQueueTableColumnHeader {...props} />
            {props.queue == null &&
                [...Array(10)].map((o, i) => <EmployeesQueueTableLoader key={`eqt_${i}`} />)
            }
            {props.queue && props.queue.resultCount === 0 &&
                <EmployeesQueueTableNoResults />
            }
            {props.queue && props.queue.resultCount > 0 &&
                props.queue.items.map((t, i) =>
                    <EmployeesQueueTableRow employee={t} key={`qtr_${i}`} {...props}/>
                )
            }
            {props.queue && props.queue.count > props.limit &&
                <EmployeesQueueTablePages queue={props.queue} onSetOffset={props.onSetOffset} />
            }
        </div>
    );
}

EmployeesQueueTable.propTypes = {
    sort: PropTypes.string,
    onSortChanged: PropTypes.func.isRequired,
    queue: PropTypes.object,
    onSetOffset: PropTypes.func.isRequired,
    isAssociateQueue: PropTypes.bool,
    associateFullName: PropTypes.string
}

export default EmployeesQueueTable